// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"19c576f0","3724":"19c576f0","5325":"36af0fd6","7004":"3d877e94"}[chunkId] + ".chunk.css";
};